module.exports = __webpack_public_path__ + "static/media/homapge1.4427cd23.jpg";